module.exports = __webpack_public_path__ + "df9ceb244b27cc880809d97ce5ddf01d-ui_pipelines_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/undergroundInfrastructure/assets/ui_pipelines_2x.jpg
// module id = 840
// module chunks = 0